<div [hidden]="!viewNotification" style="position: absolute; top: 10%; left: 0; width: 310px; z-index: 9999"></div>
<nav class="site-header">
  <div class="site-header-inner">
    <a class="site-brand" [routerLink]="'/home'">
      <img class="site-brand-logo" src="/assets/new-logo/SCBCLOGO-WHITE.svg" alt="Knowledge Gate" />
      <img class="site-brand-vision" src="/assets/new-logo/2030.png" alt="2030" />
    </a>

    <div #siteLinks class="site-links" [class.mobile-d-none]="isLogin">
      <a class="site-link" [hidden]="externalCoordinator?.status == true" [routerLink]="'/home'"
        routerLinkActive="active">
        <i class="pi pi-home"></i>
        <span>{{ "الرئيسية" | translator }}</span>
      </a>

      <a class="site-link" *ngIf="hasPermission('CONTENT','r') || (!isLogin && hasOpenViewPermission())"
        [hidden]="externalCoordinator?.status == true" [routerLink]="'/all-data-view'" routerLinkActive="active">
        <i class="pi pi-th-large"></i>
        <span>{{ "دليل الخدمات" | translator }}</span>
      </a>

      <a class="site-link" *ngIf="hasPermission('KNOWLEDGE_LIBRARY','r') || (!isLogin && hasOpenLibraryPermission())"
        [hidden]="externalCoordinator?.status == true" [routerLink]="'/knowledge-library'" routerLinkActive="active">
        <i class="pi pi-file"></i>
        <span>{{ "Knowledge Library" | translator }}</span>
      </a>

      <a class="site-link" *ngIf="externalCoordinator.status != true && isLogin" href="/training/continuous?view=available">
        <i class="fa-solid fa-graduation-cap"></i>
        <span>{{ "Training" | translator }}</span>
      </a>

      <a class="site-link" *ngIf="externalCoordinator.status != true && isLogin" [class.active]="isFavoritesPage()"
        (click)="navigateToFav()">
        <i class="pi pi-star"></i>
        <span>{{ "Favorite" | translator }}</span>
      </a>

      <a class="site-link" *ngIf="externalCoordinator.status != true && isLogin" [routerLink]="'/products-view'"
        routerLinkActive="active">
        <i class="pi pi-briefcase"></i>
        <span>{{ "Products and Services" | translator }}</span>
      </a>
    </div>

    <div class="site-actions">
      <button *ngIf="externalCoordinator.status != true && isLogin" type="button" class="site-bell"
        [class.read]="newNotificationCount === 0" (click)="toggleNotificationPanel()"
        [attr.aria-label]="(newNotificationCount > 0 ? ('Notifications' | translator) : ('All caught up' | translator))"
        [attr.title]="(newNotificationCount > 0 ? null : ('All caught up' | translator))">
        <i class="pi pi-bell bell-size"></i>
        <span *ngIf="newNotificationCount > 0" class="site-bell-badge">{{ newNotificationCount }}</span>
      </button>

      <ng-container *ngIf="isLogin">
        <span class="site-divider"></span>

        <div class="site-account" (click)="$event.stopPropagation()">
          <button type="button" class="site-account-btn" [class.open]="accountMenuOpen"
            (click)="accountMenuOpen = !accountMenuOpen" [attr.aria-expanded]="accountMenuOpen">
            <i class="pi pi-angle-down site-account-caret"></i>
            <span class="site-account-label">{{ "حسابي" | translator }}</span>
            <span class="site-avatar">
              <img *ngIf="avatar; else avatarIcon" [src]="avatar" alt="" />
              <ng-template #avatarIcon><i class="pi pi-user"></i></ng-template>
            </span>
          </button>

          <div class="site-menu" *ngIf="accountMenuOpen" (click)="accountMenuOpen = false">
            <div class="site-menu-name" *ngIf="userName">{{ userName }}</div>
            <a class="site-menu-item" [hidden]="externalCoordinator?.status == true" [routerLink]="'/user-profile'">
              <i class="pi pi-user"></i>{{ "Profile personly" | translator }}
            </a>
            <a class="site-menu-item" [routerLink]="'/password-change'">
              <i class="pi pi-key"></i>{{ "Password Reset" | translator }}
            </a>
            <a class="site-menu-item danger" (click)="handleLogout()">
              <i class="pi pi-sign-out"></i>{{ "Log out" | translator }}
            </a>
          </div>
        </div>
      </ng-container>

      <button *ngIf="!isLogin" type="button" class="site-login" (click)="handleLogout()">
        <i class="pi pi-sign-in"></i>
        <span>{{ "Login" | translator }}</span>
      </button>

      <app-sidenav [hidden]="externalCoordinator?.status == true || !isLogin"></app-sidenav>
    </div>
  </div>
</nav>

<!-- <hr class="hr border-white" /> -->

<p-sidebar class="v4-left-p-sidebar" [(visible)]="viewNotification">
  <ng-template pTemplate="header">
    <span class="d-flex w-100">
      <img class="not-img" src="../../../assets/icons/SBC/speaker-vedios.svg" alt="loading" />
      <span class="not-head mx-2"> {{ "Notifications" | translator }}</span>
    </span>
  </ng-template>
  <ng-template pTemplate="content" class="p-0" style="padding: 0px">
    <div class="notify-scroll">
      <!-- <span class="clone-times" (click)="viewNotification = false;"><i class="pi pi-times"></i></span> -->
      <div class="notification">
        <div *ngFor="let notification of notifications" role="button" (click)="markSeen(notification)" class="d-flex align-items-center notification-row {{
            isSeen(notification)
              ? 'notification-box notification-row-read'
              : 'notification-box-active notification-row-unread'
          }}">
          <span *ngIf="!isSeen(notification)" class="notification-unread-dot"
            [attr.aria-label]="('Unread' | translator)"></span>
          <span *ngIf="isSeen(notification)" class="notification-read-check"
            [attr.aria-label]="('Read' | translator)">
            <i class="pi pi-check"></i>
          </span>
          <div>
            <img *ngIf="checkIsImage(notification.image); else elseBlock" class="notification-img"
              src="{{ staticFileUrl + notification.image }}" onerror="this.src='../../../assets/person-placeholder.jpg'"
              alt="loading" />
            <ng-template #elseBlock>
              <div class="notification-img d-center">
                <i class="{{ notification.image }}" style="font-size: 2rem"></i>
              </div>
            </ng-template>
          </div>
          <div class="column">
            <span class="{{
                isSeen(notification)
                  ? 'notification-label'
                  : 'notification-label-active'
              }}">{{ notification.title }}</span>
            <span class="{{
                isSeen(notification)
                  ? 'notification-label-deactive'
                  : 'notification-label-active'
              }}" style="font-weight: 500; font-size: 12px">{{ notification.name }}</span>
            <span class="{{
                isSeen(notification)
                  ? 'notification-text'
                  : 'notification-text-active'
              }}">{{ notification.message }}</span>
            <span class="{{
                isSeen(notification)
                  ? 'notification-date'
                  : 'notification-date-active'
              }}">{{ getDateDifference(notification.createdAt) }}</span>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="w-100 v4-bg-bottom p-2 d-flex flex-column gap-2">
      <button *ngIf="newNotificationCount > 0" class="w-100 v4-left-nav-btn" (click)="markAllSeen()">
        <i class="pi pi-check-circle me-1"></i>
        {{ "markAllRead" | translator }}
      </button>
      <div *ngIf="hasPermission('VIEW_NOTIFICATIONS', 'a')">
        <button class="w-100 v4-left-nav-btn" routerLink="/notification">
          {{ "showAll" | translator }}
        </button>
      </div>
    </div>
  </ng-template>
</p-sidebar>